<template>
  <div>
    <!--Content_all-->
    <section class="content_all cont_int product_intern produc_c2">
      <Header></Header>
      <div class="wrapper_m">
        <section class="titulo">
          <h1>MARKETING</h1>
          <div class="tab_tittle right">
            <a href="marketing">
              <span>BTL/POP</span>
            </a>
            <a href="marketing-google">
              <span>Google</span>
            </a>
            <a href="marketing-facebook" class="active">
              <span>Facebook</span>
            </a>
            <a href="marketing-instagram">
              <span>Instagram</span>
            </a>
            <!--<a href="marketing-detail">Precio</a>-->
          </div>
        </section>
      </div>

      <!--Descripcion-->
      <section class="wrapper_m p_b_30">
        <ul class="detail_1">
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/facebook/img1.jpg" />
              </div>
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt">
                  <h2 class="morado">Llega al público adecuado</h2>
                  <p>Selecciona tu público por edades, intereses, comportamientos en línea y muchas más variable, para ejecutar tus campañas.</p>
                </div>
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt txt_right">
                  <h2 class="morado">Escoge los lugares para que la gente te vea</h2>
                  <p>Ten un espacio geográfico donde quieres que tus clientes encuentren tus mensajes y publicaciones.</p>
                </div>
              </div>
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/btl/img2.jpg" />
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/facebook/img3.jpg" />
              </div>
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt">
                  <h2 class="morado">Genera tráfico de valor</h2>
                  <p>Incrementa el volumen de visitantes a tus canales que tiene mayor probabilidad de ejecutar una compra.</p>
                </div>
              </div>
            </section>
          </li>
        </ul>
      </section>
      <!--Fin Descripcion-->
      <Footer></Footer>
    </section>
    <!--Fin Content_all-->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  }
}
</script>
